import React from "react"
import { IScheduleDocument, ISchedulePatternTemplate } from "../../../../../models"
import _ from "lodash"
import * as hierarchyHelper from "../../../../../helpers/hierarchyHelper"
import * as scheduleHelper from "../../../../../helpers/scheduleHelper"
import * as timeHelper from "../../../../../helpers/timeHelper"
import moment from "moment"
import ScheduleResourcePlannerWeeklyDailyItem from "./ScheduleResourcePlannerWeeklyDailyItem"
import DonutChart from "../../../../common/donutChart/DonutChart"
import { Paper } from "material-ui"

interface IProps {
  schedule: IScheduleDocument
  handleAssignEmployee(assignPatternTemplate: ISchedulePatternTemplate): void
  handleUnAssignEmployee(unAssignPatternTemplate: ISchedulePatternTemplate): void
}

const ScheduleResourcePlannerWeeklyItem: React.SFC<IProps> = (props: IProps) => {
  const dayLength = scheduleHelper.durationInDays([props.schedule])
  const startDate = scheduleHelper.getStartDate([props.schedule])
  let dayDates = []
  for (let i = 0; i < dayLength; i++) {
    dayDates.push(moment(startDate).add(i, "day"))
  }

  const schedules = props.schedule.Schedules.filter(i => !i.Deleted)
  const totalShiftsCount = schedules.length
  const unfilledShiftsCount = schedules.filter(pt => !pt.AssignedUserId).length
  const filledPercent = Math.round((totalShiftsCount - unfilledShiftsCount) * 100 / totalShiftsCount)
  let agencyPercentage = null

  return (
    <Paper style={{ margin: 10, width: "100%" }}>
      <div style={{ padding: 10, position: "relative" }} id="ScheduleViewPlace">
        <div style={{ display: "grid", gridTemplateColumns: "auto min-content", marginBottom: 15 }}>
          <div style={{ gridColumn: 1 }}>
            <div style={{ fontSize: 10 }}>
              {hierarchyHelper.getFullyQualifiedLevelNameById(props.schedule.HierarchyId)}
            </div>
            <div style={{ fontSize: 16, fontWeight: 500 }}>
              {props.schedule.Name}
            </div>
            <div style={{ fontSize: 10 }}>
              {moment(timeHelper.keepConvertUTCToLocal(props.schedule.StartDate)).format("MM/DD/YY")} - {moment(timeHelper.keepConvertUTCToLocal(props.schedule.EndDate)).format("MM/DD/YY")}
            </div>
          </div>
          <div style={{ gridColumn: 2 }}>
            {totalShiftsCount ?
              <DonutChart
                value={filledPercent}
                valueLabelYPosition={24}
                strokeWidth={4}
                size={40}
                textValStyle={{ fontSize: 12 }}
                percentStyle={{ fontSize: 12 }}
                textLabelStyle={{ display: "none" }}
                spaceBetweenValAndLabel={0}
              /> :
              ""
            }
          </div>
        </div>
        {props.schedule.Schedules.length > 0 ?
          <div style={{ display: "flex" }}>
            {dayDates.map(date =>
              <ScheduleResourcePlannerWeeklyDailyItem
                key={date}
                patternTemplates={props.schedule.Schedules}
                dayDate={date}
                handleAssignEmployee={props.handleAssignEmployee}
                handleUnAssignEmployee={props.handleUnAssignEmployee}
              />
            )}
          </div> :
          <div style={{ textAlign: "center", padding: 30 }}><b>No Shifts</b></div>
        }
      </div>
    </Paper>
  )
}

export default ScheduleResourcePlannerWeeklyItem